<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    viewBox="-120 0 1700 1224" 
    :aria-labelledby="iconName" 
    role="presentation"
  >
    <title :id="iconName" lang="en">{{iconName}} icon</title>    
        <g :color="iconColor" :fill="iconColor" :stroke="iconColor" stroke-width="5">
<path d="M491.145 33.497c-101.456 24.744-195.044 83.639-263.304 172.621-139.019 178.040-139.019 431.427 0 609.467 136.523 180.405 373.913 236.631 574.023 139.018l-14.27-29.461c-186.414 90.933-406.069 39.058-533.514-129.351v-0.46c-129.663-166.060-129.663-402.9 0-568.958 127.446-166.136 347.197-220.238 533.514-129.352l14.27-29.92c-100.102-48.83-209.263-58.348-310.717-33.604z"></path>
<path d="M255.92 872.666l-20.715 25.778c82.952 65.875 187.788 104.953 293.226 104.953v-32.683c-97.251 0-195.198-36.653-272.512-98.050z"></path>
<path d="M528.43 20.609c-105.182 0-210.055 36.921-293.226 105.414l20.715 25.318c77.097-63.491 175.002-97.588 272.512-97.588z"></path>
<path d="M599.32 65.72c-154.593 0-296.987 85.732-372.861 222.797-78.115 137.053-78.276 308.148 0 445.131 75.916 139.325 218.557 222.797 372.861 222.797v-33.142c-142.546 0-273.61-76.593-343.861-205.764l-0.461-0.46c-72.481-126.841-72.481-285.607 0-412.45h0.461c70.25-126.904 201.489-206.226 343.861-206.226z"></path>
<path d="M528.43 20.609v33.142h70.89v-33.142z"></path>
<path d="M528.43 970.713v32.683h70.89v-32.683z"></path>
<path d="M825.338 65.72c-237.8 0-431.322 198.488-431.322 445.131s193.524 445.592 431.322 445.592c240.062 0 431.322-199.055 431.322-445.592s-191.26-445.131-431.322-445.131zM825.338 98.403c221.88 0 398.18 182.901 398.18 412.45s-176.297 412.45-398.18 412.45c-219.431 0-398.18-183.009-398.18-412.45s178.749-412.45 398.18-412.45z"></path>
<path d="M832.243 91.497c-223.781 0-405.083 189.151-405.083 419.353s181.304 419.815 405.083 419.815c223.781 0 405.544-189.612 405.544-419.815s-181.764-419.353-405.544-419.353zM832.243 124.641c205.167 0 372.402 173.324 372.402 386.211s-167.235 386.67-372.402 386.67c-205.167 0-371.941-173.785-371.941-386.67s166.774-386.211 371.941-386.211z"></path>
<path d="M832.243 204.737c-162.502 0-294.606 137.276-294.606 306.115s132.104 306.574 294.606 306.574c164.717 0 297.369-137.736 297.369-306.574s-132.65-306.115-297.369-306.115zM832.243 237.421c146.387 0 264.225 121.737 264.225 273.432s-117.838 273.432-264.225 273.432c-143.888 0-261.464-121.737-261.464-273.432s117.575-273.432 261.464-273.432z"></path>
<path d="M599.32 923.3v33.142h226.019v-33.142z"></path>
<path d="M599.32 65.72v32.683h226.019v-32.683z"></path>
<path d="M827.639 435.358c-39.946 0-72.731 33.855-72.731 75.492s32.785 75.492 72.731 75.492c41.637 0 73.191-34.64 73.191-75.492s-31.553-75.492-73.191-75.492zM827.639 468.503c24.354 0 40.048 17.209 40.048 42.35s-15.694 42.35-40.048 42.35c-21.333 0-40.048-17.996-40.048-42.35s18.715-42.35 40.048-42.35z"></path>
<path d="M830.403 204.737l-0.46 32.683c144.030 2.215 261.923 124.222 261.923 273.432 0 151.693-117.724 271.214-261.923 273.432l0.46 33.142c162.192-2.496 294.147-137.736 294.147-306.574 0-166.61-131.785-303.617-294.147-306.115z"></path>
<path d="M533.034 16.005v33.142c18.855 0 39.209 0.136 55.239 4.143l7.826-32.222c-21.679-5.421-44.209-5.063-63.065-5.063z"></path>
<path d="M590.113 970.713c-17.343 2.168-38.555 2.058-58.922 4.604l4.143 32.683c17.343-2.168 38.555-2.058 58.922-4.604z"></path>
<path d="M601.622 21.068c-185.694-26.877-369.098 60.947-469.068 221.875-102.362 163.292-102.362 372.524 0 535.816 99.972 163.368 283.16 249.038 468.609 224.638l-4.143-32.683c-172.792 22.735-343.095-56.536-436.387-208.986v-0.46c-95.614-152.526-95.614-348.305 0-500.831 93.291-150.177 263.378-231.66 435.926-206.685z"></path>
<path d="M1013.766 270.21c76.941 124.297 151.079 249.894 0 480.048l498.525-251.606zM1530.427 501.805v0l-459.544 186.866z"></path>
<path d="M776.767 453.98h369.347v111.311h-369.347v-111.311z"></path>
        </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'IconRfOut'
    },
    width: {
      type: [Number, String],
      default: 50
    },
    height: {
      type: [Number, String],
      default: 50
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>